import React from "react";
import { Link } from "react-router-dom";
import "../styles/CartDropdown.css";
import { formatPrice } from "../utils/formatPrice";

const CartDropdown = ({ cartItems = [], onRemoveItem, onUpdateQuantity, isLoggedIn, user, onClose }) => {
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + ((item.retailPrice || 0) * (item.quantity || 1)),
    0
  );

  const guestCartId = localStorage.getItem("guestCartId");
  const isMobile = window.innerWidth <= 768;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) {
      return "/noImage.jpg";
    }
    if (imageUrl.startsWith('http')) {
      return imageUrl;
    }
    return  `${API_BASE_URL}${imageUrl}`;
  };

  const handleQuantityChange = async (e, itemId, newQuantity) => {
    e?.stopPropagation();
    e?.preventDefault();

    try {
      const effectiveItemId = itemId === null ? e.currentTarget.dataset.productId : itemId;
      if (!effectiveItemId) throw new Error("Item ID is required");

      if (newQuantity <= 0) {
        await onRemoveItem(effectiveItemId);
        return;
      }

      if (typeof onUpdateQuantity === 'function') {
        await onUpdateQuantity(effectiveItemId, newQuantity);
      }
    } catch (error) {
      console.error("Error updating quantity:", error);
      alert(`Failed to update quantity: ${error.message}`);
    }
  };

  const getItemPrice = (item) => {
    // First try anRetailPrice, then ret, then price, default to 0
    return item.retailPrice;
  };

  return (
    <div className={`cart-dropdown ${isMobile ? 'mobile-fullscreen' : ''}`}>
      {isMobile && (
        <div className="mobile-dropdown-header">
          <h3>Korpa</h3>
          <button className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>
      )}
      {!isMobile && <h3>Korpa</h3>}
      <div className="cart-dropdown-content">
        {cartItems.length > 0 ? (
          <>
            <ul className="cart-items-list">
              {cartItems.map((item) => {
                const imageUrl = item.imageUrl || item.product?.imageUrl || item.product?.images?.[0]?.imageUrl;
                const itemPrice = getItemPrice(item);
                return (
                  <li key={item.compositeKey || item.productId} className="cart-item">
                    <img
                      src={getImageUrl(imageUrl)}
                      alt={item.product?.name || item.name || "Product"}
                      className="cart-item-image"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/noImage.jpg";
                      }}
                    />
                    <div className="cart-item-info">
                    <Link to={`/home/product/${item.productId}`} className="cart-product-name" title={item.name}>
                        <p>{item.product?.name || item.name}</p>
                    </Link>
                      <p>Šifra: {item.product?.productCode || item.productCode || "N/A"}</p>
                      <div className="quantity-control">
                        <button
                          className="quantity-btn decrease"
                          onClick={(e) => handleQuantityChange(e, item.id, item.quantity - 1)}
                          data-product-id={item.productId}
                          disabled={item.quantity <= 1}
                        >
                          −
                        </button>
                        <span className="quantity-display">{item.quantity}</span>
                        <button
                          className="quantity-btn increase"
                          onClick={(e) => handleQuantityChange(e, item.id, item.quantity + 1)}
                          data-product-id={item.productId}
                        >
                          +
                        </button>
                      </div>
                      <p>Cena: {formatPrice(itemPrice)} RSD</p>
                    </div>
                    <button
                      className="remove-item-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemoveItem(item.productId);
                      }}
                    >
                      X
                    </button>
                  </li>
                );
              })}
            </ul>
            <div className="total-price">
              <p>Ukupno: {formatPrice(totalPrice)} RSD</p>
            </div>
                       <Link
             to="/buy-form"
             state={{
               cartItems: cartItems,
               isGuest: !isLoggedIn,
               guestCartId: guestCartId,
               user: user,
               isLoggedIn: isLoggedIn,  
               userId: user?.id
             }}
             className="buy-button"
             onClick={(e) => {
               e.stopPropagation();

               if (isMobile && onClose) onClose();
             }}
           >
             Kupi
           </Link>
          </>
        ) : (
          <p className="empty-cart-message">Korpa je prazna!</p>
        )}
      </div>
    </div>
  );
};

CartDropdown.defaultProps = {
  cartItems: [],
  onRemoveItem: () => {},
  onUpdateQuantity: () => {},
  isLoggedIn: false,
  user: null,
  onClose: () => {}
};

export default CartDropdown;